<template>
  <div>
    <generateOrder />
  </div>
</template>

<script>
import generateOrder from './components/generateOrder.vue';

export default {
  name: 'index.vue',
  components: {
    generateOrder,
  },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus"></style>
